import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { Input as TaroInput, View, } from "../_core/components";
import { useDefaultValue } from "../_util/use-default";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
import { Textarea } from "./Textarea";
import { noop } from "../_util/noop";
import { useConfig } from "../_util/use-config";
export var Input = forwardRefWithStatics(function Input(props, ref) {
    var classPrefix = useConfig().classPrefix;
    var _a = useDefaultValue(props, ""), _b = _a.type, type = _b === void 0 ? "text" : _b, value = _a.value, onChange = _a.onChange, _c = _a.onInput, onInput = _c === void 0 ? noop : _c, className = _a.className, style = _a.style, restProps = __rest(_a, ["type", "value", "onChange", "onInput", "className", "style"]);
    var taroInputProps = __assign({}, restProps);
    if (type === "password") {
        taroInputProps.type = "text";
        taroInputProps.password = true;
    }
    else {
        taroInputProps.type = type;
    }
    return (React.createElement(View, { className: classNames(classPrefix + "-field", classPrefix + "-field__input", className, {
            "is-disabled": taroInputProps.disabled,
        }), style: style },
        React.createElement(TaroInput, __assign({}, taroInputProps, { ref: ref, className: classPrefix + "-field__input-item", placeholderClass: classPrefix + "-field__placeholder", value: value, onInput: function (event) {
                onChange(event.detail.value, { event: event });
                return onInput(event);
            } }))));
}, {
    displayName: "Input",
    Textarea: Textarea,
});
//# sourceMappingURL=Input.js.map